import { getCategoriesbyIdEnterprise } from '@/services/graphs/api.categorization'

export default async function getOptionsAndData(empresaId) {
  const response = await getCategoriesbyIdEnterprise(empresaId)
  const data = response[0]

  const controleImplementado =
    data.PhysicalControlImplemented +
    data.OrganizationalControlImplemented +
    data.PeopleControlImplemented +
    data.TechnologicalControlImplemented

  const controleParcial =
    data.PhysicalControlPartiallyImplemented +
    data.OrganizationalControlPartiallyImplemented +
    data.PeopleControlPartiallyImplemented +
    data.TechnologicalControlPartiallyImplemented

  const controleNaoImplementado =
    data.PhysicalControlNotImplemented +
    data.OrganizationalControlNotImplemented +
    data.PeopleControlNotImplemented +
    data.TechnologicalControlNotImplemented

  const totalControles =
    data.PhysicalControl +
    data.OrganizationalControl +
    data.PeopleControl +
    data.TechnologicalControl

  const naoSeAplica =
    data.TechnologicalControlNotApplicable +
    data.PhysicalControlNotApplicable +
    data.OrganizationalControlNotApplicable +
    data.PeoplesControlNotApplicable

  const chartData = {
    datasets: [
      {
        data: [
          controleImplementado,
          naoSeAplica > 0 ? naoSeAplica : 0,
          controleParcial,
          controleNaoImplementado,
        ],
        backgroundColor: [
          'rgba(0, 176, 80)',
          'rgba(191, 191, 191)',
          'rgba(255, 192, 0)',
          'rgba(255, 0, 0)',
        ],
        borderColor: [
          'rgba(255, 255, 255)',
          'rgba(255, 255, 255)',
          'rgba(255, 255, 255)',
          'rgba(255, 255, 255)',
        ],
        borderWidth: 2,
      },
    ],
  }

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
      },
    },
  }

  return { chartData, options }
}
